import { toBigInt } from "../service/web3/checkout";


export const copyToClipboard = (text) => {
  navigator.clipboard.writeText(text);
  alert("Text copied the clipboard!!");
};

export const formatNumber = (num,decimal) => {
  if (num === undefined) return "0.000";
  if (typeof num === "string") num = parseFloat;
  return num.toLocaleString(undefined, {
    minimumFractionDigits:decimal || 3,
    maximumFractionDigits: decimal || 3,
  });
};

export const formatEthers = (value, decimals = 18, decimalPlaces = 3) => {
  if (value === undefined) return "0.000";
  const bigIntValue = toBigInt(value);
  const divisor = toBigInt(10) ** toBigInt(decimals);
  const formattedValue = bigIntValue / divisor;
  return formatNumber(formattedValue, decimalPlaces);
};

export const shortenedTxHash = (hash) => {
  if (!hash) return "N/A";
  return `${hash.slice(0, 6)}...${hash.slice(-4)}`;
};